"use client";

import type { TaggedProduct } from "../../_types/content";
import ProductCard from "./ProductCard";
import FeaturedCarousel from "./ui/FeaturedCarousel";

interface FeaturedProductCarouselProps {
  products: readonly TaggedProduct[];
  compact?: boolean;
}

export default function FeaturedProductCarousel({
  products,
  compact = false,
}: FeaturedProductCarouselProps) {
  return (
    <FeaturedCarousel
      title="Featured products"
      items={products}
      getKey={({ id }) => id}
      compact={compact}
      renderItem={(product) => (
        <ProductCard
          product={product}
          presentation={compact ? "compact" : "carousel"}
        />
      )}
    />
  );
}
